<template>
  <div :class="`wphk-act-coupon-${couponLang}`">
    <Coupon
      :lang="couponLang"
      :couponInfo="formattedCouponInfo"
      @getCoupon="btnClick"
      @couponClick="couponClick"
    >
      <template slot="coupon-btn-ui">
        <slot name="basic-coupon-btn-comp"></slot>
      </template>
    </Coupon>
  </div>
</template>

<script lang="ts">
import { Coupon } from '@tencent/wphk-act-base-ui';
import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import CouponMixin from './mixin.vue';
// 基本优惠券
@Component({
  components: {
    Coupon,
  },
})
export default class BasicCoupon extends mixins(CouponMixin) {
}
</script>

<style scoped></style>
